import { inject, Injectable, InjectionToken } from '@angular/core';

import {
  createCoreCapabilityBlockedEvent,
  createCoreWorkspaceUnavailableEvent,
  createUnexpectedRenderFailureEvent,
} from './failure-events';

/*
 * The custom-element host is supplied per mounted Angular MFE instance.
 * Dispatching from this element lets the Shell identify the reporting MFE
 * from the trusted DOM event path.
 */
export const MFE_HOST_ELEMENT = new InjectionToken<HTMLElement>('MFE_HOST_ELEMENT');

@Injectable()
export class RuntimeFailureReporter {
  private readonly hostElement = inject(MFE_HOST_ELEMENT);

  reportCoreCapabilityBlocked(): void {
    this.hostElement.dispatchEvent(createCoreCapabilityBlockedEvent());
  }

  reportCoreWorkspaceUnavailable(): void {
    this.hostElement.dispatchEvent(createCoreWorkspaceUnavailableEvent());
  }

  reportUnexpectedRenderFailure(): void {
    this.hostElement.dispatchEvent(createUnexpectedRenderFailureEvent());
  }
}
